export default "__VITE_ASSET__LlaDk5ft__"